import React from 'react'
import PaymentsDetailContainer from 'containers/panel/admin/payments-detail-container'

const PaymentsDetailPage = () => {
  return (
    <PaymentsDetailContainer/>
  )
}

export default PaymentsDetailPage